import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#7720FF',
      light: '#9E61FF',
      dark: '#5C18CC',
    },
    secondary: {
      main: '#18FF9E',
      light: '#4CFFB5',
      dark: '#13CC7E',
    },
    error: {
      main: '#FF7577',
      light: '#FF9D9E',
      dark: '#CC5D5F',
    },
    background: {
      default: '#0D0D0D',
      paper: '#222222',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#C4C4C4',
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Helvetica', sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.375rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    body1: {
      fontSize: '1rem',
      fontFamily: "'DM Sans', 'Helvetica', sans-serif",
    },
    body2: {
      fontSize: '0.875rem',
      fontFamily: "'DM Mono', monospace",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          /* WebKit */
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#0D0D0D',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#7720FF',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#9E61FF',
          },
          /* Firefox */
          scrollbarWidth: 'thin',
          scrollbarColor: '#7720FF #0D0D0D',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // backgroundImage: 'radial-gradient(50% 50% at 92% -9%, rgba(0,0,0,1) 82%, rgba(111,22,255,1) 100%)',
        borderRadius: '24px',
          // boxShadow: 'inset 0px -17px 38px rgba(255,255,255,0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '100px',
        },
      },
    },
    MuiTable :{
      styleOverrides: {
        root: {
          fontFamily: "'DM Sans', 'Helvetica', sans-serif",
        },
      },
    },
    MuiTableCell :{
      styleOverrides: {
        root: {
          fontFamily: "'DM Sans', 'Helvetica', sans-serif",
        },
      },
    }
  },
});